import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import 'mailcheck';
import { T_ } from '@shared/translation';
import { cdn_url } from '@shared/cdn';
import { usernameSuggester } from '@shared/username-suggester';
import autoFillForms from '@shared/auto-fill-forms';
import tpl from '../templates/signup.html';
import logoTpl from '../templates/fl-logo.html';
import '../models/signup';

/*
 * Signup view controller: bind the signup view
 * with its model.
 */
export default Backbone.View.extend({
  template: _.template(tpl),

  initialize(options) {
    // Event bus
    this.vent = options.vent;
    // View options
    this.options = {
      isModalUpsell: options.isModalUpsell,
      upsellTemplate: options.upsellTemplate,
      title: options.title || T_('Sign up for free today!'),
      loginTitle: options.loginTitle,
      coupon: options.coupon || false,
      couponHiddenDefault: options.couponHiddenDefault || false,
      welcomeMsg: options.welcomeMsg || '',
      invitedSignup: options.invitedSignup || false,
      inviterFullname: options.inviterFullname || '',
      skipCatcha: options.skipCaptcha && false,
      hideFacebook: !!options.hideFacebook,
      hideLookingFor: !!options.hideLookingFor,
      isLoginSignup: this.options.isLoginSignup,
      isFreemarket: this.options.isFreemarket,
      signupSkipCaptchaHash: options.signupSkipCaptchaHash || false,
      // LPO-910
      hideConfirmPassword: options.hideConfirmPassword,
      // LJ-375
      switchToAlternateSignup: this.options.hasOwnProperty(
        'switchToAlternateSignup',
      )
        ? this.options.switchToAlternateSignup
        : false,
      saveFormFields: this.options.saveFormFields || false,
      isInvitedCollaborator: this.options.isInvitedCollaborator || false,
      isInvitedContestCollaborator:
        this.options.isInvitedContestCollaborator || false,
      projectId: options.projectId,
    };
    this.$el = $(this.el);
    // Fields validation events
    this.model.bind('email:valid', this.onValidEmail, this);
    this.model.bind('email:invalid', this.onInvalidEmail, this);
    this.model.bind('username:valid', this.onValidUsername, this);
    this.model.bind('username:invalid', this.onInvalidUsername, this);
    this.model.bind('password:valid', this.onValidPassword, this);
    this.model.bind('password:invalid', this.onInvalidPassword, this);
    this.model.bind('confirmpwd:valid', this.onValidConfirmpwd, this);
    this.model.bind('confirmpwd:invalid', this.onInvalidConfirmpwd, this);
    this.model.bind('looking_for:valid', this.onValidLookingFor, this);
    this.model.bind('looking_for:invalid', this.onInvalidLookingFor, this);
    // Captcha is required
    this.model.bind('captcha', this.onCaptchaRequired, this);
    this.model.bind('error', this.onSignupError, this);
    this.model.bind('success', this.onSignupSuccess, this);
    // Report previous error
    this.previousError = options.error;

    if (this.options.saveFormFields) {
      const inputFields = ['email', 'username', 'looking_for'];
      autoFillForms.init('signup_page_save_fields', inputFields);
    }
  },

  // UI Events
  events: {
    'submit .user-signup-form': 'submit',
    'click .close': 'close',
    'keyup input[name="email"]': 'checkEmail',
    'keyup input[name="username"]': 'checkUsername',
    'keyup input[name="password"]': 'checkPassword',
    'keyup input[name="confirmpwd"]': 'checkConfirmpwd',
    'change input[name="looking_for"]': 'checkLookingFor',
    'blur input[name="email"]': 'checkEmail',
    'blur input[name="username"]': 'checkUsername',
    'blur input[name="password"]': 'checkPassword',
    'blur input[name="confirmpwd"]': 'checkConfirmpwd',
    'click .switch-to-login': 'switchToLogin',
    'click #fb-login-btn': 'clickFBLogin',
    'click #new-email-suggestion-content': 'fillSuggestedEmail',
    'change #signup_form': 'storeFormData',
    'click #redeem_coupon': 'toggleCouponField',
  },

  onValidLookingFor() {
    const lookingFor = this.$el.find('.lookingfor-step');
    lookingFor.find('.lookingfor-error').hide();
    lookingFor.removeClass('is-valid').removeClass('is-invalid');
  },

  onInvalidLookingFor(reason) {
    const lookingFor = this.$el.find('.lookingfor-step');
    this.$el.find('#signup_btn').removeClass('processing');
    lookingFor
      .find('.lookingfor-error')
      .text(reason)
      .show();
    lookingFor.removeClass('is-valid').addClass('is-invalid');
  },

  checkLookingFor: _.debounce(function() {
    const lookingForCheck = this.$el.find('input[name="looking_for"]:checked');
    const lookingForHidden = this.$el.find(
      'input[name="looking_for"][type="hidden"]',
    );
    let lookingFor = lookingForCheck.val();

    if (lookingForCheck.length === 0 && lookingForHidden.length === 1) {
      lookingFor = lookingForHidden.val();
    }

    this.model.set({ looking_for: lookingFor }, { silent: true });
    this.model.isValidLookingFor();

    this.vent.trigger('signup:toggleLookingFor', lookingFor);
  }, 300),

  // Email
  checkEmail: _.debounce(function() {
    const email = this.$el.find('input[name="email"]');
    this.model.set({ email: email.val() }, { silent: true });
    this.model.isValidEmail();
  }, 300),

  onInvalidEmail(reason) {
    this.$el.find('#signup_btn').removeClass('processing');
    const email = this.$el.find('.email-step');
    email
      .find('.email-error')
      .text(reason)
      .show();
    email.removeClass('is-valid').addClass('is-invalid');
  },

  onValidEmail() {
    const that = this;
    const email = this.$el.find('.email-step');
    email.find('.email-error').hide();
    email.removeClass('is-invalid').addClass('is-valid');
    email.find('input[name=email]').mailcheck({
      suggested(element, suggestion) {
        const suggestionContainer = that.$el.find('#new-email-suggestion');
        suggestionContainer
          .find('#new-email-suggestion-content')
          .html(suggestion.full);
        suggestionContainer.show();
      },
      empty() {
        that.$el.find('#new-email-suggestion').hide();
      },
    });
    if (
      !this.model.get('username') &&
      !this.$el.find('input[name="email"]').is(':focus')
    ) {
      const emailInput = this.$el.find('input[name="email"]').val();
      usernameSuggester.init();
      usernameSuggester.suggestUsername(emailInput).done(resp => {
        that.$el
          .find('input[name="username"]')
          .val(resp.result.recommended_name);
        that.model.set(
          { username: resp.result.recommended_name },
          { silent: true },
        );
        that.trigger('username:valid');
        that.$el.find('#new-username').focus();
      });
    }
  },

  // Username
  checkUsername: _.debounce(function() {
    const username = this.$el.find('input[name="username"]');
    this.model.set({ username: username.val() }, { silent: true });
    this.model.isValidUsername();
  }, 300),

  onInvalidUsername(reason) {
    this.$el.find('#signup_btn').removeClass('processing');
    const username = this.$el.find('.username-step');
    username
      .find('.username-error')
      .text(reason)
      .show();
    username.removeClass('is-valid').addClass('is-invalid');
  },

  onValidUsername() {
    const username = this.$el.find('.username-step');
    username.find('.username-error').hide();
    username.removeClass('is-invalid').addClass('is-valid');
  },

  // Password
  checkPassword: _.debounce(function() {
    const password = this.$el.find('input[name="password"]');
    const confirmpwd = this.$el.find('input[name="confirmpwd"]');
    // LPO-910
    if (this.options.hideConfirmPassword) {
      confirmpwd.val(password.val());
    }
    this.model.set({ password: password.val() }, { silent: true });
    this.model.isValidPassword();
    if (confirmpwd.val()) {
      this.checkConfirmpwd();
    }
  }, 300),

  onInvalidPassword(reason) {
    this.$el.find('#signup_btn').removeClass('processing');
    const password = this.$el.find('.password-step');
    password
      .find('.password-error')
      .text(reason)
      .show();
    password.removeClass('is-valid').addClass('is-invalid');
  },

  onValidPassword() {
    const password = this.$el.find('.password-step');
    password.find('.password-error').hide();
    password.removeClass('is-invalid').addClass('is-valid');
  },

  // Password confirmation
  checkConfirmpwd: _.debounce(function() {
    const confirmpwd = this.$el.find('input[name="confirmpwd"]');
    const password = this.$el.find('input[name="password"]');
    this.model.set(
      {
        password: password.val(),
        confirmpwd: confirmpwd.val(),
      },
      { silent: true },
    );
    this.model.isValidPassword();
    this.model.isValidConfirmpwd();
  }, 300),

  onInvalidConfirmpwd(reason) {
    this.$el.find('#signup_btn').removeClass('processing');
    const confirmpwd = this.$el.find('.confirmpwd-step');
    confirmpwd
      .find('.confirmpwd-error')
      .text(reason)
      .show();
    confirmpwd.removeClass('is-valid').addClass('is-invalid');
  },

  onValidConfirmpwd() {
    const confirmpwd = this.$el.find('.confirmpwd-step');
    confirmpwd.find('.confirmpwd-error').hide();
    confirmpwd.removeClass('is-invalid').addClass('is-valid');
  },

  // Submit.
  submit(e) {
    e.preventDefault();
    const signupBtn = this.$el.find('#signup_btn');
    if (signupBtn.hasClass('processing')) {
      return false;
    }
    signupBtn.addClass('processing');
    const email = this.$el.find('input[name="email"]');
    const username = this.$el.find('input[name="username"]');
    const password = this.$el.find('input[name="password"]');
    const confirmpwd = this.$el.find('input[name="confirmpwd"]');
    const coupon = this.$el.find('input[name="coupon"]');
    const lookingForCheck = this.$el.find('input[name="looking_for"]:checked');
    const lookingForHidden = this.$el.find(
      'input[name="looking_for"][type="hidden"]',
    );
    let lookingFor = lookingForCheck.val();

    if (lookingForCheck.length === 0 && lookingForHidden.length === 1) {
      lookingFor = lookingForHidden.val();
    }

    this.$el.find('.signup-error').hide();
    this.vent.trigger('signup:submit');
    this.model.set(
      {
        email: email.val(),
        username: username.val(),
        password: password.val(),
        confirmpwd: confirmpwd.val(),
        looking_for: lookingFor,
        coupon: coupon.val(),
        proj_id: this.options.projectId,
      },
      { silent: true },
    );
    this.model.signup();
  },

  onCaptchaRequired(captcha) {
    this.vent.trigger('show:captcha', {
      captcha,
      signupModel: this.model,
    });
  },

  onSignupError(reason) {
    this.$el.find('#signup_btn').removeClass('processing');
    this.$el
      .find('.signup-error')
      .text(reason)
      .show();
    setTimeout(() => {
      this.$el.find('.signup-error').hide();
    }, 5000);
  },

  onSignupSuccess(response) {
    this.$el.find('.signup-success');
    this.vent.trigger('signup:success', {
      redirectUrl: response.redirectUrl,
      isEmployer: this.model.isEmployer(),
    });
  },

  switchToLogin(e) {
    e.preventDefault();
    const options = {
      signupModel: this.model,
      title: this.options.loginTitle,
      signupTitle: this.options.title,
      hideFacebook: this.options.hideFacebook,
      hideLookingFor: this.options.hideLookingFor,
      isLoginSignup: this.options.isLoginSignup,
      isFreemarket: this.options.isFreemarket,
      switchToAlternateSignup: this.options.switchToAlternateSignup,
    };
    this.vent.trigger('show:login', options);
  },

  showFBLogin() {
    this.vent.trigger('show:fblogin', { loginModel: this.model });
  },

  // Render
  render() {
    this.$el.html(
      this.template({
        model: this.model.toJSON(),
        options: this.options,
        T_,
      }),
    );

    if (this.options.isModalUpsell && this.options.upsellTemplate) {
      this.$el.find('#upsell-content').html(this.options.upsellTemplate);
    }

    if (!this.options.isFreemarket) {
      this.$el.find('#fl-logo').html(_.template(logoTpl)({ cdn_url }));
    }
    // Show previous errors
    if (this.previousError) {
      this.$el.find('.signup-error').text(this.previousError);
    }
    return this;
  },

  storeFormData() {
    if (this.options.saveFormFields) {
      autoFillForms.storeFormData();
    }
  },

  close(event, clickedFacebookButton) {
    if (!this.options.isLoginSignup) {
      this.vent.trigger('close', clickedFacebookButton);
    }
  },

  clickFBLogin(event) {
    this.vent.trigger('click:fblogin');
    this.close(event, true);
  },

  /**
   * Destroy the view. Unbind all references to enable the view
   * to be garbage collected and remove the el from the DOM.
   */
  destroy() {
    this.model.unbind('email:valid', this.onValidEmail, this);
    this.model.unbind('email:invalid', this.onInvalidEmail, this);
    this.model.unbind('username:valid', this.onValidUsername, this);
    this.model.unbind('username:invalid', this.onInvalidUsername, this);
    this.model.unbind('password:valid', this.onValidPassword, this);
    this.model.unbind('password:invalid', this.onInvalidPassword, this);
    this.model.unbind('confirmpwd:valid', this.onValidConfirmpwd, this);
    this.model.unbind('confirmpwd:invalid', this.onInvalidConfirmpwd, this);
    this.model.unbind('captcha', this.onCaptchaRequired, this);
    this.model.unbind('error', this.onSignupError, this);
    this.model.unbind('success', this.onSignupSuccess, this);
    this.remove();
  },

  fillSuggestedEmail(e) {
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }
    this.$el
      .find('input[name="email"]')
      .val(this.$el.find('#new-email-suggestion-content').text());
    this.$el.find('#new-email-suggestion').hide();
    this.model.isValidEmail();
  },

  toggleCouponField() {
    this.$el.find('#coupon-step').toggleClass('is-coupon-step-hidden');
  },
});
